"use client"

import { motion, useInView } from "framer-motion"
import { useRef } from "react"
import { standardScrollConfig } from "@/utils/animations"
import SectionHeader from "@/app/(landing)/components/SectionHeader"
import SectionSubheader from "@/app/(landing)/components/SectionSubheader"
import { Button } from "../ui/button"
import Link from "next/link"
import { ArrowRight } from "lucide-react"

export function TestimonialsSection({
  children,
}: {
  children: React.ReactNode
}) {
  const sectionRef = useRef<HTMLElement>(null)
  const isInView = useInView(sectionRef, standardScrollConfig)

  return (
    <section
      ref={sectionRef}
      className=" bg-ivory py-16 md:py-28 lg:py-32 space-y-4 md:space-y-12 px-4"
    >
      <div className="container mx-auto text-center">
        <SectionHeader ref={sectionRef}>
          From crypto to cooking, & everything in between
        </SectionHeader>

        <SectionSubheader ref={sectionRef}>
          Discover what writers, thinkers, and storytellers are talking about
          today.
        </SectionSubheader>
      </div>
      <div className=" flex flex-col space-y-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.7, delay: 0.3 }}
        >
          {children}
        </motion.div>

        <div className="text-center ">
          <Link href="/home">
            <Button variant="secondary" className="mx-auto ">
              Explore all <ArrowRight size={16} className="ml-2" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  )
}
